import { useAlertsContext } from '../../context/AlertsContext'
import { FloatingAlerts } from '../../collections/FloatingAlerts'

const Alerts = () => {
  const { alerts } = useAlertsContext()
  return <FloatingAlerts alerts={alerts} />
}

export { Alerts }
